var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "#F0F0F0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.895431 0 2V26C0 27.1046 0.895431 28 2 28H13.9781V16.9H11.2V12.6667H13.9781V9.8224C13.9781 7.9703 14.4103 6.57023 15.2746 5.62214C16.1389 4.67404 17.5794 4.2 19.5961 4.2H23.0533V8.43333H20.9543C20.1723 8.43333 19.6681 8.56562 19.4418 8.83021C19.2154 9.09479 19.1022 9.53576 19.1022 10.1531V12.6667H23.0533L22.5594 16.9H19.1022V28H26C27.1046 28 28 27.1046 28 26V2C28 0.895431 27.1046 0 26 0H2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4d16d67158ae021318ead40417ef0b9a.svg";
export { ForwardRef as ReactComponent };